export default __webpack_public_path__ + "static/media/zwembad.410168d5.svg";